import { NetworkProductName as Product } from 'main/gql/globalTypes'

export { Product }

export function productEnabled(products: Product[], product: Product): boolean {
  return !!products.length && products.includes(product)
}
